import { ComponentStyleConfig } from '@chakra-ui/react';
import { textStyles } from '../../common';

export const FormControlStyles: ComponentStyleConfig = {
  baseStyle: (_props) => ({
    container: {
      flexWrap: 'wrap',
      alignItem: 'center',
    },
    helperText: {
      color: 'text.primary',
      ...textStyles['body-sm'],
      mt: 0,
    },
  }),
};
